<!--
트래킹검수 > 검수화면 > 검수대상 리스트 컴포넌트 > 일괄검수 >
하우스그룹
------------------------------------
-->
<template>
    <div class="uk-card uk-card-small uk-card-default">
        <controller
            :csrf-token="csrfToken"
            :batch="houseGroup.batch"
            :total-amount="houseGroup.total_amount"
            :house-name="houseGroup.name"
            :house-id="houseGroup.id"
            :house-code="houseGroup.code"

            @check:exception="msg => $emit('check:exception', msg)"
            @done:pack="house_id => $emit('done:pack', house_id)"
            @done:ready="$emit('done:ready')"
        >
        </controller>
        <div class="prod-area">
            <table class="prod-info">
                <colgroup>
                    <col style="width: 30px">
                    <col style="width: 110px">

                    <col style="width: 100px">

                    <col style="width: 100px">
                    <col>
                    <col>
                    <col>

                    <col>
                    <col style="width: 80px">

                    <col style="width: 100px">
                    <col style="width: 120px">
                    <col style="width: 100px">

                </colgroup>
                <thead>
                <tr>
                    <th>
                        <app-batch-all-item-checker :items="houseGroup.batch.items" title="전체선택" :disabled="disableCheckbox"></app-batch-all-item-checker>
                    </th>
                    <th>
                        <i class="material-icons">image</i>
                    </th>

                    <th>
                       정상
                    </th>

                    <th>
                       QTY
                    </th>
                    <th>
                       SIZE
                    </th>
                    <th>
                       COLOR
                    </th>
                    <th>
                       SKU
                    </th>

                    <th class="name">
                       상품명
                    </th>
                    <th>
                       단가
                    </th>
                    <th>
                       상세
                    </th>

                    <th>
                       오류설정
                    </th>

                    <th>
                       보류보관
                    </th>
                </tr>
                </thead>
                <prod
                    v-for="(prod, index) in houseGroup.prods"
                    :key="prod.id"
                    :prod="prod"
                    :csrf-token="csrfToken"
                    :login-user-id="loginUserId"
                    :disable-checkbox="disableCheckbox"

                    @done:error="$emit('done:error', null)"
                    @done:hold="$emit('done:hold', null)"
                    @done:ready="$emit('done:ready', null)"
                    @done:pack="house_id => $emit('done:pack', house_id)"
                >
                </prod>

            </table>

        </div>

    </div>
</template>

<script>
    export default {
        components: {
            'prod': require('./prod.vue').default,
            'controller': require('./controller.vue').default,
        },

        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },

            /**
             * 일괄검수용 하우스그룹 객체
             */
            houseGroup: {
                type: Object,
                default: null,
            },

            /**
             * 일괄검수에서
             * 현재 선택된 하우스그룹ID
             */
            activeHouseGroupId: {
                type: Number,
                default: null,
            },
        },

        data: function () {
            return {
            };
        },

        computed: {
            /**
             * 체크박스를 disable 처리할지 여부
             */
            disableCheckbox() {
                // 선택된 하우스그룹이 없음
                if (! this.activeHouseGroupId) {
                    return false;
                }

                // 선택된게 있으면 나 자신인 경우만 disable 안함
                return this.houseGroup.id !== this.activeHouseGroupId;
            },
        },

        methods: {
        },
    }
</script>

<style lang="scss" scoped>



    .prod-area {
        //padding: 5px;

        .prod-info {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;

            th {
                background-color: #fafafa;
                font-size: 1.25rem;
                text-align: center;
                padding: 10px;
                font-weight: normal;
                border: 1px solid #cfcfcf;

                &.name {
                    text-align: left;

                }

                .uk-checkbox {
                    width: 20px;
                    height: 20px;
                }

                .material-icons {
                    vertical-align: middle;
                    font-size: 28px;
                }

            }

        }
    }
</style>